import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/materialCost`;

export const ROUTE: RouteDefinition = `${baseRoute}/materialCost`;

export const URL = (): RouteDefinition => `${baseRoute}/materialCost`;
